// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EerNb","comment":"styles_comment__2xwtY"};